import { CountryCodes } from '@/enums/general'

export const ShipmentStatuses = Object.freeze({
  onHold: -2,
  pending: -1,
  approved: 0,
  shipped: 1,
  delivered: 2,
  waste: 66
})

export const DeliveryTimes = Object.freeze({
  [CountryCodes.austria]: { earliest: 4, latest: 7 },
  [CountryCodes.belgium]: { earliest: 4, latest: 7 },
  [CountryCodes.denmark]: { earliest: 4, latest: 7 },
  [CountryCodes.germany]: { earliest: 4, latest: 7 },
  [CountryCodes.spain]: { earliest: 6, latest: 9 },
  [CountryCodes.france]: { earliest: 4, latest: 7 },
  [CountryCodes.netherlands]: { earliest: 1, latest: 4 },
  [CountryCodes.unitedKingdom]: { earliest: 4, latest: 7 },
  [CountryCodes.sweden]: { earliest: 4, latest: 7 },
  [CountryCodes.italy]: { earliest: 4, latest: 7 },
  [CountryCodes.poland]: { earliest: 4, latest: 7 },
  [CountryCodes.switzerland]: { earliest: 4, latest: 7 },
  [CountryCodes.ireland]: { earliest: 2, latest: 5 },
  [CountryCodes.luxembourg]: { earliest: 4, latest: 7 },
  [CountryCodes.portugal]: { earliest: 2, latest: 5 },
  [CountryCodes.finland]: { earliest: 3, latest: 6 },
  [CountryCodes.norway]: { earliest: 4, latest: 7 },
  [CountryCodes.czechRepublic]: { earliest: 2, latest: 5 }
})

export const CancelDays = Object.freeze({
  [CountryCodes.austria]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.belgium]: {
    waitingDays: 4,
    daysToCancel: 10
  },
  [CountryCodes.denmark]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.germany]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.spain]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.france]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.netherlands]: {
    waitingDays: 4,
    daysToCancel: 10
  },
  [CountryCodes.unitedKingdom]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.sweden]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.italy]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.poland]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.switzerland]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.ireland]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.luxembourg]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.portugal]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.finland]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.norway]: {
    waitingDays: 7,
    daysToCancel: 14
  },
  [CountryCodes.czechRepublic]: {
    waitingDays: 7,
    daysToCancel: 14
  }
})

export const DeliveryDates = Object.freeze({
  [CountryCodes.austria]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.belgium]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.denmark]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.germany]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.spain]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.france]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.netherlands]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.unitedKingdom]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.sweden]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.italy]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.poland]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.switzerland]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.ireland]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.luxembourg]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.portugal]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.finland]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.norway]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  },
  [CountryCodes.czechRepublic]: {
    firstDeliveryDate: 17,
    lastDeliveryDate: 23
  }
})

export const DeliveryTimeInDays = Object.freeze({
  [CountryCodes.austria]: 7,
  [CountryCodes.belgium]: 4,
  [CountryCodes.denmark]: 7,
  [CountryCodes.germany]: 7,
  [CountryCodes.spain]: 9,
  [CountryCodes.france]: 7,
  [CountryCodes.netherlands]: 4,
  [CountryCodes.unitedKingdom]: 7,
  [CountryCodes.sweden]: 7,
  [CountryCodes.italy]: 7,
  [CountryCodes.poland]: 5,
  [CountryCodes.switzerland]: 7,
  [CountryCodes.ireland]: 7,
  [CountryCodes.luxembourg]: 7,
  [CountryCodes.portugal]: 7,
  [CountryCodes.finland]: 7,
  [CountryCodes.norway]: 7,
  [CountryCodes.czechRepublic]: 7
})
